var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"roundup-button-old",class:[_vm.color, { loading: _vm.loading }],attrs:{"disabled":_vm.disabled,"type":_vm.nativeType || 'button'},on:{"click":function($event){return _vm.$emit('click', this)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }